import { render, staticRenderFns } from "./PostSurvey.vue?vue&type=template&id=155b406a&scoped=true&"
import script from "./PostSurvey.vue?vue&type=script&lang=js&"
export * from "./PostSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155b406a",
  null
  
)

export default component.exports